<template>
  <v-layout column pa-1>
    <v-flex
      headline
      id="prompt"
      class="my-2"
      >
      <mrx-translation :token="this.title"></mrx-translation>
    </v-flex>
    <v-flex 
      subheading
      class="grey--text text--darken-2 my-1"
      id="instructions"
      >
      <mrx-translation :token="this.prompt"></mrx-translation>
    </v-flex>
      
    <template v-for="(collection, index) in collections">
      <v-subheader class="title pa-2" :id="`${index}-header`">
          <mrx-translation :token="`app.summary.${index}.title`"></mrx-translation>
        </v-subheader>
        <list v-for="panel in collection"
          v-bind:item="panel"
          :key="panel.id"
          ></list>
    </template>

    <v-dialog v-model="discardDialog" persistent max-width="290">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          id="discard-observation"
          v-bind="attrs"
          v-on="on"
          color="moderate"
          v-show="showDiscardButton">
            <v-icon left>{{ icons.mdiAccountRemove }}</v-icon>
            <mrx-translation token="app.observation.button.remove.title"></mrx-translation>
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="headline">
          <mrx-translation token="app.observation.remove.dialog.title"></mrx-translation>
        </v-card-title>
        <v-card-text>
          <mrx-translation token="app.observation.remove.dialog.message"></mrx-translation>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn id="cancel-discard-observation" color="green darken-1" text @click="discardDialog = false">
            <mrx-translation token="app.observation.remove.dialog.cancel"></mrx-translation>
          </v-btn>
          <v-btn id="confirm-discard-observation" color="green darken-1" text @click="remove">
            <mrx-translation token="app.observation.remove.dialog.ok"></mrx-translation>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import Bottom from '@/components/layouts/Bottom'
  import List from '@/components/layouts/List'
  import groupBy from 'lodash.groupby'
  import { mapGetters, mapActions } from 'vuex'
  import icons from '@/mixins/icons'

  export default {
    components: { Bottom, List },
    name: 'Observation',
    mixins: [icons],
    data() {
      return {
        discardDialog: false,
        title: 'app.observations.title',
        prompt: 'app.observations.prompt',
        nextLink: null
      }
    },

    computed: {
      collections() {
        return groupBy([].concat(this.acceptedObservations, this.rejectedObservations, this.transferedObservations), 'collections')
      },
      showDiscardButton() {
        if (this.panel.options && this.panel.options.hideDiscardButton) return false
        return true
      },
      ...mapGetters({
        track: 'v4/track/current',
        panel: 'v4/panel/current',
        acceptedObservations: 'v4/observation/accepted',
        rejectedObservations: 'v4/observation/rejected',
        transferedObservations: 'v4/observation/transfered',
      })
    },

    methods: {
      ...mapActions({
        apply: 'v4/observation/apply',
        next: 'v4/navigate/next'
      }),

      async remove() {
        await this.$store.dispatch('v4/observation/reset', { force: true })
        await this.$store.dispatch('v4/track/clear')
        this.next()
      }
    },

    mounted() {
      this.apply()
    },

    updated() {
      this.$nextTick(function() {
        if (this.$route.params.offset) {
          window.scroll(0, this.$route.params.offset)
        }
      })
    }
  }
</script>


<style scoped>
</style>
